import { Button, Typography } from '@mui/material';
import { Lock } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/** Upsell / not-configured state when no Generate Video operation can run for this user. */
export const ServiceUnavailable: React.FC<{ reason: string | null }> = ({ reason }) => {
  const { t } = useTranslation();
  const inPackage = reason && reason !== 'not_in_package';

  return (
    <div className="mx-auto flex max-w-lg flex-col items-center gap-4 rounded-xl border border-gray-200 bg-white p-8 text-center shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <Lock size={32} className="text-gray-400 dark:text-slate-500" />
      <Typography variant="h6" className="text-gray-900 dark:text-slate-100">
        {t('services.generateVideo.unavailableTitle')}
      </Typography>
      <Typography className="text-gray-500 dark:text-slate-400">
        {t(`services.generateVideo.unavailable.${reason ?? 'not_in_package'}`)}
      </Typography>
      {!inPackage && (
        <Button component={Link} to="/subscription?feature=generate_video" variant="contained">
          {t('services.generateVideo.upgrade')}
        </Button>
      )}
    </div>
  );
};
